<template>
  <div class="product-block-inner step-two">

    <span class="product-block-span step-two-top-margin step-two-text">
      <h1 v-html="title"></h1>
      <h3 v-html="subtitle"></h3>

      <DemoButton :buttonMessage="'Software, Use Attach'"></DemoButton>
    </span>

    <span class="product-block-span step-two-images animated">

      <img class="phone-image player-attach-content" src="../../../../assets/winter-2019/hero-phone-16.png">
      <video class="phone-image-inner" src="https://s3.amazonaws.com/attach-videos/7bhucfwTouiPY0o6lbn5_vertical-demos-480-sm.mov" muted playsinline autoplay loop></video>
    </span>

  </div>
</template>

<script>

import logos from '../logos'

import DemoButton from './GetDemoButton'

export default {
  data() {
    return {
      title: 'Deliver customer experiences that solve your industry’s pain points',
      subtitle: 'Beauty and Personal Care: improve consumers’ ability to shade and color match online. eGrocery brands: protect your margins by increasing your average order value in one click. Apparel & Footwear: stay ahead of demand by understanding which SKUs are most popular & where.',
    }
  },
  components: {
    DemoButton
  },
  mounted() {},
  methods: {
    logoClass(index) {
      return index % 2 == 0 ? 'even-class' : 'odd-class'
    },
    getSocialImageUrl(name) {
      var images = require.context('../../../../assets/social-logos/')
      return images(`./${name}.png`)
    },
    getPlayerLink(playerId) {
      return `https://multicart-dev.mikmak.tv/${playerId}?internalVisualTest=true&cb=3251&buildView=true`
    }
  },
  computed: {},
  watch: {}
}
</script>

<style scoped>

  .product-block-inner {
    display: flex;
    margin: 24px auto;
    padding: 0px 15%;
    overflow: hidden;
    min-height: 600px;
  }

  .step-two-images {
    margin-right: -100px;
  }

  .step-two-text {
    margin-right: 124px;
  }

  .product-block-span {
    display: inline-block;
    width: 50%;
    text-align: left;
  }

  .product-block-span h1 {
    font-size: 32px;
    font-family: "Work Sans", sans-serif;
    background: linear-gradient(135deg, #24af94 0%,#31c4a8 69%,#19d09d 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    line-height: 34px;
  }

  .product-block-span h3 {
    font-size: 18px;
    font-weight: normal;
    font-family: "Work Sans", sans-serif;
  }

  @media only screen and (max-width: 1000px) {
    .product-block-inner {
      display: block;
      min-height: 850px;
    }

    .product-block-span {
      display: block;
      width: 100%;
      text-align: center;
    }

    .product-block-span h1 {
      font-size: 24px;
    }

    .product-block-span h3 {
      max-width: 400px;
      margin: 0 auto;
      margin-bottom: 32px;
    }

    .step-two-text {
      margin-right: 0px;
    }
  }

  .social-logo {
    background: white;
    height: 36px;
    width: 36px;
    display: inline-block;
    border-radius: 100px;
    padding: 8px;
    border: 4px solid #f3f3f3;
  }

  .social-logo img {
    display: block;
    width: 36px;
  }

  .odd-class {
    margin-bottom: -24px;
    margin-right: -24px;
    margin-left: -24px;
  }

  @media only screen and (max-width: 1200px) {
    .odd-class {
      margin-right: -24px;
      margin-left: -24px;
    }
  }

  @media only screen and (max-width: 800px) {
    .odd-class {
      margin-right: -30px;
      margin-left: -30px;
    }
  }

  @media only screen and (max-width: 800px) {
    .product-block-inner {
      padding: 12px;
      min-height: 300px;
      margin-top: 48px;
    }

    .hero-social-logos {
      text-align: center;
      margin-bottom: 32px;
    }
  }

  /* Component Specific */

  .step-two-top-margin {
    margin-top: 80px;
  }

  .phone-image {
    position: absolute;
    width: 370px;
    z-index: 4;
    height: 660px;
  }

  .phone-image-inner {
    position: absolute;
    width: 367px;
    z-index: 3;
    margin-top: -36px;
    border: none;
    -ms-transform: scale(0.7);
    transform: scale(0.7);
    background-color: white;
  }

  .macbook-image {
    position: absolute;
    width: 658px;
    z-index: 2;
    margin-left: 181px;
    margin-top: 120px;
  }

  .macbook-image-inner {
    position: absolute;
    z-index: 1;
    margin-left: -206px;
    margin-top: -75px;
    border: none;
    -ms-transform: scale(0.4);
    transform: scale(0.4);
    height: 772px;
  }

  @media only screen and (max-width: 1000px) {

    .step-two-images {
      text-align: center;
      margin-left: 118px;
    }

    .step-two-top-margin {
      max-width: 90%;
      margin: 0 auto;
    }

    .phone-image {
      width: 263px;
      height: 478px;
      position: relative;
      margin-left: -231px;
    }

    .phone-image-inner {
      margin-top: -211px;
      margin-left: -362px;
      width: 460px;
      height: 825px;
      -ms-transform: scale(0.4);
      transform: scale(0.4);
    }

    .macbook-image {
      width: 300px;
      margin-left: -66px;
      margin-top: 76px;
    }

    .macbook-image-inner {
      width: 907px;
      margin-left: -380px;
      margin-top: -64px;
      transform: scale(0.3);
      height: 456px;
    }
  }

  .demo-button {
    background: linear-gradient(135deg, #24af94 0%,#31c4a8 69%,#19d09d 100%);
    color: #fff;
    font-size: 22px;
    text-decoration: none;
    cursor: pointer;
    min-width: 224px;
    max-width: 300px;
    text-align: center;
    padding: 8px;
    border-radius: 3px;
    margin: 48px 0px;
    display: block;
    cursor: pointer;
    box-shadow: 0 2px 6px #00000024;
    font-weight: lighter;
    text-decoration: none;
    letter-spacing: 1px;
    border: none;
  }

  .hero-commerce-logos {

  }

</style>



// WEBPACK FOOTER //
// StepVerticalValueProps.vue?534dc4bc